// video files
// import moana from "../assets/videos/moana.mp4"
// import vlc from "../assets/videos/vlc.mp4"

// cover images files
import doa_cover from "../assets/images/doa-cover.jpg"
import cola_cover from "../assets/images/cola-cover.jpg"

const videos = [
  {
    id: 1,
    title: "Nikomeshe",
    descr:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque auctor pulvinar urna eget. Libero porttitor lectus orci odio.",
    src: "6ev_MIoa704",
    coverImg: cola_cover,
    singThursday: false,
    featured: false,
    artist: "Pabo",
    type: "video/mp4",
  },
  {
    id: 2,
    title: "Maiana",
    descr:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque auctor pulvinar urna eget. Libero porttitor lectus orci odio.",
    src: "3brgLdE-pzI",
    coverImg: "",
    singThursday: false,
    featured: true,
    artist: "Pabo",
    type: "video/mp4",
  },
  {
    id: 3,
    title: "Kido",
    descr:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque auctor pulvinar urna eget. Libero porttitor lectus orci odio.",
    src: "m_FYrQ5DsxI",
    coverImg: cola_cover,
    singThursday: false,
    featured: false,
    artist: "Pabo",
    type: "video/mp4",
  },
  {
    id: 4,
    title: "SEASON FINALE",
    descr:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque auctor pulvinar urna eget. Libero porttitor lectus orci odio.",
    src: "euzXrOxxqO0",
    coverImg: "",
    singThursday: true,
    artist: "Mishel, Tamara and Joh Dreamer",
    featured: true,
    type: "video/mp4",
  },
  {
    id: 5,
    title: "Doa",
    descr:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque auctor pulvinar urna eget. Libero porttitor lectus orci odio.",
    src: "FUjfQSTbuHQ",
    coverImg: doa_cover,
    singThursday: false,
    featured: true,
    artist: "Pabo",
    type: "video/mp4",
  },
  {
    id: 6,
    title: "S01E03",
    descr:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque auctor pulvinar urna eget. Libero porttitor lectus orci odio.",
    src: "BDfju0cSdoM",
    coverImg: "",
    singThursday: true,
    artist: "MoeDalz",
    featured: false,
    type: "video/mp4",
  },
  {
    id: 7,
    title: "Like that",
    descr:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque auctor pulvinar urna eget. Libero porttitor lectus orci odio.",
    src: "ixqEqfDEo7s",
    coverImg: cola_cover,
    singThursday: false,
    artist: "Startone",
    featured: true,
    type: "video/mp4",
  },
  {
    id: 8,
    title: "S01E01",
    descr:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque auctor pulvinar urna eget. Libero porttitor lectus orci odio.",
    src: "9tUkXNIFRa4",
    coverImg: "",
    singThursday: true,
    artist: "Naby",
    featured: false,
    type: "video/mp4",
  },
]

export default videos
